<template>
  <div>
    <!-- Hero Section -->
    <Section>
      <div class="text-center max-w-4xl mx-auto">
        <h1 class="text-4xl md:text-5xl font-bold text-ink mb-6">
          {{ $t('features.title') }}
        </h1>
      </div>
    </Section>

    <!-- Detailed Features -->
    <div v-for="(feature, index) in detailedFeatures" :key="feature.key">
      <Section :background="index % 2 === 0 ? 'white' : 'gray'">
        <FeatureBlock
          :title="$t(feature.title)"
          :description="$t(feature.description)"
          :image-src="feature.image"
          :image-position="feature.imagePosition"
        />
      </Section>
    </div>

    <!-- CTA Section -->
    <Section>
      <div class="text-center max-w-3xl mx-auto">
        <h2 class="text-3xl font-bold text-ink mb-4">
          Ready to Streamline Your Operations?
        </h2>
        <p class="text-lg text-muted mb-8">
          See how E2M can transform your multi-channel retail management.
        </p>
        <BaseButton variant="primary" size="lg">
          {{ $t('common.requestDemo') }}
        </BaseButton>
      </div>
    </Section>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import Section from '@/components/Section.vue'
import BaseButton from '@/components/BaseButton.vue'
import FeatureBlock from '@/components/FeatureBlock.vue'
import { detailedFeatures } from '@/data/features'

const { t } = useI18n()

useHead({
  title: () => `${t('features.title')} - E2M`,
  meta: [
    { name: 'description', content: () => t('features.title') },
    { property: 'og:title', content: () => `${t('features.title')} - E2M` },
    { property: 'og:description', content: () => t('features.title') }
  ]
})
</script>